import {
    Portal,
    PopoverContent,
    PopoverBody,
    List,
    ListItem,
    ListIcon,
} from '@chakra-ui/react';

import { AccountAvatar } from 'pages/accounts/users/new/cellRenderer/AccountAvatar';

const AvatarPopoverContent = ({ darkMode, bg, isRA, isRingGroup }) => {
    const listItemColorUser = isRA ? 'gray.500' : darkMode ? 'white' : 'black';
    const listItemColorRA = !isRA ? 'gray.500' : darkMode ? 'white' : 'black';

    let listItem;
    if (isRingGroup) {
        listItem = (
            <ListItem color={listItemColorRA}>
                <ListIcon
                    as={() => (
                        <AccountAvatar
                            isRA
                            size="xs"
                            formattedValue="Ring Group"
                        />
                    )}
                    mr={2}
                />
                <span className="ml-1">Ring Group</span>
            </ListItem>
        );
    } else if (isRA) {
        listItem = (
            <ListItem color={listItemColorRA}>
                <ListIcon
                    as={() => (
                        <AccountAvatar
                            isRA
                            size="xs"
                            formattedValue="Resource Account"
                        />
                    )}
                    mr={2}
                />
                <span className="ml-1">Resource Account</span>
            </ListItem>
        );
    } else {
        listItem = (
            <ListItem color={listItemColorUser}>
                <ListIcon
                    as={() => <AccountAvatar size="xs" formattedValue="User" />}
                    mr={2}
                />
                <span className="ml-1">User</span>
            </ListItem>
        );
    }

    return (
        <Portal>
            <PopoverContent bg={bg}>
                <PopoverBody>
                    <List>{listItem}</List>
                </PopoverBody>
            </PopoverContent>
        </Portal>
    );
};
export { AvatarPopoverContent };
